import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '@/api/settings';
import { useAuth } from '@/hooks/useAuth';

const isDesktop = !!window.psbDesktop?.isDesktop;

function useAiSettings() {
  const { isLoggedIn } = useAuth();
  return useQuery({
    queryKey: ['settings', 'ai'],
    queryFn: () => settingsApi.getSettings().then((r) => r.data),
    enabled: isLoggedIn,
    staleTime: 60000,
  });
}

/**
 * BYOK 总开关（服务端用户设置 ai.byok_enabled）：关闭时外部（非 ollama）模型
 * 在右下角控制台与各页面选择器全站隐藏。
 * 未设置时的默认值：桌面端开（BYOK 是桌面既有行为），网页端关（干净默认，
 * 用户在 设置 → AI 里打开并填 key 后才出现外部模型）。
 */
export function useByokEnabled(): boolean {
  const { data } = useAiSettings();
  const v = (data?.ai as Record<string, unknown> | undefined)?.byok_enabled;
  return v === undefined || v === null ? isDesktop : !!v;
}

/** 用户级单模型开关（ai.disabled_models）：被用户关掉的 BYOK 模型 catalog id 集合 */
export function useDisabledModels(): Set<string> {
  const { data } = useAiSettings();
  const list = (data?.ai as Record<string, unknown> | undefined)?.disabled_models;
  return useMemo(() => new Set(Array.isArray(list) ? (list as string[]) : []), [list]);
}
